module.exports = __webpack_public_path__ + "img/my-media-fill.7e1b4bc8.svg";